export const translations = {
  en: {
    welcomeBack: 'Welcome back',
    appSubtitle: 'Sawtna Jordan',
    yourName: 'Your name',
    enterName: 'Please enter your name.',
    signIn: 'Sign in',
    profile: 'Profile',
    registeredNurse: 'Registered Nurse',
    hospitalName: '',
    onShift: 'On shift',
    offShift: 'Off shift',
    endShift: 'End shift',
    startShift: 'Start shift',
    language: 'Language',
    english: 'English',
    arabic: 'العربية',
    feedback: 'Feedback',
    feedbackPlaceholder: 'Tell us more',
    feedbackRequired: 'Please enter your feedback before submitting.',
    feedbackSubmitError: 'Could not send feedback. Please try again.',
    feedbackSubmitting: 'Sending...',
    submit: 'Submit',
    save: 'Save',
    settingsSaved: 'Settings saved.',
    thanksFeedback: 'Thanks for your feedback!',
    signOut: 'Sign out',
    patients: 'Patients',
    notes: 'Notes',
    vitals: 'Vitals',
    medications: 'Medications',
    menu: 'Menu',
    switchTo: 'Switch to',
    flowSheet: 'Flow Sheet',
    carePlans: 'Care Plans',
    noCarePlansYet: 'No care plans documented yet. Record a voice note to generate one automatically.',
    nursingDiagnosis: 'Nursing Diagnosis',
    carePlanGoals: 'Goals',
    carePlanInterventions: 'Interventions',
    addIntervention: 'Add Intervention',
    deleteIntervention: 'Delete intervention',
    carePlanEvaluation: 'Evaluation',
    active: 'Active',
    resolved: 'Resolved',
    markAsResolved: 'Mark as Resolved',
    exportPdf: 'Export PDF',
    recordingWarning: 'Recording in progress. Stop recording before switching tabs.',
    all: 'All',
    favorites: 'Favorites',
    prnAsNeeded: 'PRN / As Needed',
    prnBadge: 'PRN',
    activeTasks: 'Active tasks',
    activeCarePlans: 'Care plans',
    lastDocumented: 'Last documented',
    neverDocumented: '—',
    taskSourceVoice: 'Voice',
    taskSourceCarePlan: 'Care Plan',
    taskSourceManual: 'Manual',
    holdToDocument: 'Hold to document',
    recurringTask: 'Recurring',
    documentTask: 'Document task',
    documentToCompleteTask: 'Document to complete this task.',
    recordToCompleteTask: 'Document to complete this task.',
    recordToCompleteTaskHint: 'Fill in the note or use the microphone to document this task.',
    recordPainScoreBeforeSubmit: 'Please record pain score before submitting.',
    recordBloodSugarBeforeSubmit: 'Please record blood sugar before submitting.',
    recordBloodPressureBeforeSubmit: 'Please record blood pressure before submitting.',
    painScoreBefore: 'Pain score before',
    painScoreAfter: 'Pain score after',
    bpBefore: 'BP before',
    pulseOptional: 'Pulse (optional)',
    bloodSugarBefore: 'Blood sugar before',
    bloodSugarAfter: 'Blood sugar after',
    inrOptional: 'INR (optional)',
    injectionSite: 'Injection site',
    infusionRateOptional: 'Infusion rate (optional)',
    volumeOptional: 'Volume (optional)',
    adverseReactionNoted: 'Adverse reaction noted',
    required: 'Required',
    optional: 'Optional',
    noMedicationTasks: 'No medication tasks.',
    noPrnTasks: 'No PRN or as-needed tasks.',
    noTasksScheduled: 'No tasks scheduled.',
    shiftMorning: 'Morning Shift',
    shiftAfternoon: 'Afternoon Shift',
    shiftNight: 'Night Shift',
    filterByName: 'Filter by name',
    noPatientsFound: 'No patients found',
    room: 'Room',
    age: 'Age',
    allergies: 'Allergies',
    diagnoses: 'Diagnoses',
    activeMedications: 'Active medications',
    noneRecorded: 'None recorded',
    noMedications: 'No active medications recorded.',
    completed: 'Completed',
    scheduledInProgress: 'Scheduled / In progress',
    noCompletedTasks: 'No completed tasks yet.',
    noScheduledTasks: 'No scheduled tasks.',
    backToPatients: 'Back to patients',
    patientNotFound: 'Patient not found',
    holdToRecord: 'Hold to record',
    releaseToFinish: 'Release to finish',
    releaseToDiscard: 'Release to discard',
    swipeLeftToDiscard: 'Swipe left to discard',
    connecting: 'Connecting...',
    cancelRecording: 'Cancel recording',
    noSpeechDetected: 'No speech detected — hold the button and speak clearly.',
    noClinicalContent: 'No clinical content detected — describe patient care details and try again.',
    micDenied: 'Microphone access denied — please allow microphone permission.',
    connectionError: 'Could not reach transcription. Check your internet connection.',
    transcriptionError: 'Transcription error — please try again.',
    transcriptionBusy: 'Transcription busy — please wait a second and try again.',
    transcriptionLost: 'Transcription connection lost — please try again.',
    noNotesYet: 'No notes recorded yet',
    noVitalsYet: 'No vitals recorded yet',
    noMedicationsYet: 'No medications recorded yet',
    noReportsYet: 'No reports yet',
    analyzingTranscript: 'Analyzing transcript...',
    translating: 'Translating and normalizing...',
    detectingNoteType: 'Detecting note type...',
    generatingNote: 'Generating your note...',
    generatingMultiPatientProgress: 'Generating notes for patient {current} of {total}...',
    compilingShiftHandover: 'Compiling shift handover from session notes...',
    compilingForPatient: 'Generating handover for',
    mergingVoiceNote: 'Merging voice note into handover...',
    addFavorite: 'Add favorite',
    removeFavorite: 'Remove favorite',
    allWards: 'All Wards',
    ward_ICU: 'ICU',
    ward_Medical: 'Medical',
    ward_Surgical: 'Surgical',
    ward_Pediatrics: 'Pediatrics',
    ward_Maternity: 'Maternity',
    unknownPatient: 'Unknown Patient',
    overdueCount: '{count} overdue',
    moreMedications: '+{count} more',
    recordingHintGeneral: 'Speak naturally in Arabic, English, or both. Start with patient name or room number.',
    recordingHintPatient: 'Speak naturally in Arabic, English, or both. Clinical content only — patient is already selected.',
    preRecordHintGeneral: 'Speak naturally in Arabic, English, or both. Start with patient name or room number.',
    preRecordHintPatient: 'Speak naturally in Arabic, English, or both. No need to state patient name or room — this note is for the selected patient.',
    selectPatientTitle: 'Which patient is this for?',
    selectPatientSubtitle: 'Select the correct patient to continue. A patient must be chosen before reviewing or saving this note.',
    selectPatientMultiBadge: 'Patient {current} of {total}',
    selectPatientMultiTitle: 'Could not match this patient',
    selectPatientMultiSubtitle: 'The other patients were identified successfully. Choose who this note belongs to.',
    selectPatientHeard: 'Heard in recording',
    selectPatientRoomHeard: 'Room mentioned',
    selectPatientSegmentPreview: 'From your recording',
    selectPatientAlreadyMatched: 'Already matched',
    selectPatientOther: 'Other patients',
    patientMatchRoomAndName: 'Matched room and name',
    patientMatchRoom: 'Matched room',
    patientMatchName: 'Matched name',
    patientMatchFuzzy: 'Close name match',
    noNoteToReview: 'No note to review.',
    back: 'Back',
    reports: 'Reports',
    shiftReports: 'Shift & discharge reports',
    view: 'View',
    helpAndTutorial: 'Help & Tutorial',
    viewTutorialAgain: 'View Tutorial Again',
    languageChanged: 'Language updated.',
    pending: 'Pending',
    noPendingTasks: 'No pending tasks.',
    addTask: 'Add Task',
    taskDescription: 'Task description',
    taskDescriptionPlaceholder: 'e.g. Check vitals and pain score',
    dueTimeOptional: 'Due time (optional)',
    leaveEmptyOngoing: 'Leave empty to set as ongoing.',
    priority: 'Priority',
    normal: 'Normal',
    high: 'High',
    overdueBy: 'Overdue by {minutes}m',
    ongoing: 'Ongoing',
    dueNow: 'Due now',
    dueIn: 'Due in {minutes}m',
    dueAt: 'Due at {time}',
    markComplete: 'Mark complete',
    completedLabel: 'Completed',
    autoAdded: 'Auto-added',
    fromPreviousShift: 'From previous shift',
    updateFluid: 'Update →',
    noEntriesYet: 'No entries yet',
    shiftComplete: 'Shift complete ✓',
    completedAtManually: 'Completed at {time} — Completed manually',
    completedAtVia: 'Completed at {time} via {source}',
    fromMarRecording: 'From MAR recording',
    fromProgressNote: 'From Progress Note',
    fromHandover: 'From Handover',
    fromVitalsRecording: 'From Vitals recording',
    vitalsRecording: 'Vitals recording',
    progressNoteRecording: 'Progress Note recording',
    marRecording: 'MAR recording',
    handoverRecording: 'Handover recording',
    admissionRecording: 'Admission recording',
    dischargeRecording: 'Discharge recording',
    bloodPressure: 'Blood Pressure',
    medication: 'Medication',
    progressNote: 'Progress Note',
    progressNotePlaceholder: 'Report...',
    removeNote: 'Remove note',
    criticalHighAlert: 'Critical / High alert',
    concernsCount: '{count} concern',
    concernsCountPlural: '{count} concerns',
    warningsCount: '{count} warning',
    warningsCountPlural: '{count} warnings',
    verifyCount: '{count} item to verify',
    verifyCountPlural: '{count} items to verify',
    hide: 'Hide',
    show: 'Show',
    highAlertBanner: 'HIGH ALERT MEDICATION — Review carefully before saving.',
    verified: 'Verified',
    discard: 'Discard',
    done: 'Done',
    saveToSession: 'Save to session',
    savedThisSession: 'Saved this session',
    notesChronological: 'Chronological · 24-hour record',
    startRecordingFirstNote: 'Start recording to create your first note.',
    medicationAdministration: 'Medication administration',
    showCleaned: 'Show cleaned',
    showOriginal: 'Show original',
    followUpTasks: 'Follow-up tasks',
    add: 'Add',
    remove: 'Remove',
    noneListed: 'None listed.',
    noFollowUpTasks: 'No follow-up tasks detected.',
    fillSoapSection: 'Please fill at least one SOAP section.',
    fillVitalValue: 'Please fill at least one vital value.',
    fillMedicationField: 'Please fill at least one medication field.',
    fillSbarSection: 'Please fill at least one SBAR section.',
    fillOneField: 'Please fill at least one field before saving.',
    failedProcessRecording: 'Failed to process recording.',
    admitNewPatient: 'Admit new patient',
    reportShiftHandover: 'Shift Handover',
    reportDischarge: 'Discharge',
    reportIncident: 'Incident',
    timeLabel: 'Time',
    timeOfCare: 'Time of Care',
    lateEntry: 'Late Entry',
    today: 'Today',
    yesterday: 'Yesterday',
    notSpecified: 'Not specified',
    confirm: 'Confirm',
    cancel: 'Cancel',
    addAddendum: 'Add Addendum',
    addAddendumButton: '+ Addendum',
    addAddendumSubtitle:
      'The original note cannot be changed. This addendum will be attached to it with a new timestamp.',
    addAddendumPlaceholder: 'Describe the correction or additional information...',
    addAddendumRequired: 'Please enter addendum text.',
    saveAddendum: 'Save Addendum',
    saving: 'Saving…',
    addendumAddedAt: 'Addendum — added at {time}',
    conditionAtDischarge: 'Condition at discharge',
    dischargeMode: 'Discharge mode',
    accompaniedBy: 'Accompanied by',
    specialInstructions: 'Special instructions',
    dischargeEducation: 'Discharge education',
    followUp: 'Follow-up',
    physician: 'Physician',
    timeframe: 'Timeframe',
    patientUnderstands: 'Patient understands',
    familyUnderstands: 'Family understands',
    patientCopyArabic: 'Patient Copy (Arabic)',
    generating: 'Generating…',
    viewTranscript: 'View transcript',
    male: 'Male',
    female: 'Female',
    copy: 'Copy',
    copied: 'Copied!',
    loading: 'Loading',
    close: 'Close',
    shiftHandover: 'Shift Handover',
    fluidBalance: 'Fluid Balance',
    fluidBalanceListSubtitle: '24-hour fluid balance by patient',
    fluidBalanceNetBadge: 'Fluid Balance · Net {net}ml',
    confirmGiven: 'Confirm Given',
    notGiven: 'Not Given',
    submitDeviation: 'Submit Deviation',
    selectDeviationReason: 'Reason not given',
    otherReason: 'Other reason',
    speakOrTypeReason: 'Speak or type the reason',
    medicationDeviations: 'Deviations — not given',
    notGivenWithReason: 'Not given: {reason}',
    deviationPatientRefused: 'Patient refused',
    deviationPatientAway: 'Patient away from ward',
    deviationMedNotAvailable: 'Medication not available',
    deviationPatientNpo: 'Patient NPO',
    deviationPhysicianHeld: 'Physician held medication',
    deviationVitalsOutside: 'Vital signs outside parameters',
    deviationPatientVomited: 'Patient vomited',
    deviationOther: 'Other',
    units: 'units',
    freqWeekly: 'Weekly',
    freqBid: 'Twice daily',
    freqTid: 'Three times daily',
    freqOd: 'Once daily',
    freqDaily: 'Daily',
    freqQ4h: 'Every 4 hours',
    freqQ6h: 'Every 6 hours',
    freqQ6hPrn: 'Every 6 hours as needed',
    freqQ8h: 'Every 8 hours',
    freqPrn: 'As needed',
    freqPrnSuffix: 'as needed',
    taskPatientRepositioning: 'Patient Repositioning',
    taskNeurologicalAssessment: 'Neurological Assessment',
    taskBloodSugarMonitoring: 'Blood Sugar Monitoring',
    taskWoundSiteAssessment: 'Wound Site Assessment',
    taskPainAssessment: 'Pain Assessment',
    taskPainAssessmentPediatric: 'Pain Assessment (FLACC/Wong-Baker)',
    taskDrainOutputCheck: 'Drain Output Check',
    taskGrowthDevelopmentCheck: 'Growth and Development Check',
    taskParentGuardianUpdate: 'Parent/Guardian Update',
    taskFetalHeartRateMonitoring: 'Fetal Heart Rate Monitoring',
    taskFundalHeightAssessment: 'Fundal Height Assessment',
    taskLochiaAssessment: 'Lochia Assessment',
    taskBreastfeedingSupport: 'Breastfeeding Support',
    taskNewbornAssessment: 'Newborn Assessment',
    fluidBalanceProgress: 'In: {in}ml | Out: {out}ml | Balance: {balance}ml',
    doseMismatchMessage: 'Documented dose ({documented}) does not match the pending task dose ({expected} for {taskLabel}). Please confirm this is correct before saving.',
    doseMismatchValue: '{drugName}: documented {documented}, task expects {expected}',
    consentTitle: 'Before You Begin',
    consentSubtitle: 'Please review and accept the following before using Sawtna',
    consentTermsPrefix: "I have read and agree to Sawtna's",
    consentTermsOfService: 'Terms of Service',
    consentAnd: 'and',
    consentPrivacyPolicy: 'Privacy Policy',
    consentVoiceLabel:
      'I allow Sawtna to use my voice recordings to improve transcription accuracy. This helps Sawtna get better over time. You can still use Sawtna if you decline.',
    consentGetStarted: 'Get Started',
    consentSubmitting: 'Saving…',
    consentSubmitError: 'Could not save your consent. Please try again.',
    skip: 'Skip',
    next: 'Next',
    viewAll: 'View all',
    doctorPatients: 'Patients',
    doctorNotes: 'Notes',
    doctorSettings: 'Settings',
    doctorHowDoYouFindIt: 'How do you find it?',
    doctorFeedbackOptionalHint: 'Optional — tap a thumb, then add a note if you like.',
    doctorFeedbackThumbsUp: 'Thumbs up',
    doctorFeedbackThumbsDown: 'Thumbs down',
    doctorHome: 'Home',
    doctorFullName: 'Full name',
    doctorPhoneOptional: 'Phone (optional)',
    doctorPhone: 'Phone',
    doctorOptional: 'Optional',
    doctorSelectGender: 'Select…',
    doctorCreateAccount: 'Create Account',
    doctorHaveAccount: 'Already have an account? Sign in',
    doctorBackToEntry: 'Back to account type',
    doctorGetStarted: 'Get Started',
    doctorSignupStep1Title: 'Create your account',
    doctorSignupStep1Body: 'Name, email, and password — takes under a minute.',
    doctorSignupStep2Title: 'Your clinic',
    doctorSignupStep2Body: 'Optional details for PDFs and your profile. You can skip this.',
    doctorSignupContinue: 'Continue',
    doctorSignupFinish: 'Start using Sawtna',
    doctorSignupSkip: 'Skip for now',
    doctorSpecialty: 'Specialty',
    doctorCountry: 'Country',
    doctorNoteFormat: 'Note format',
    doctorClinicNamePlaceholder: 'e.g. Al-Noor Clinic',
    doctorOnboardAddPatient: 'Add your first patient',
    doctorOnboardAddPatientBody: 'Tap + to add a patient',
    doctorOnboardRecord: 'Record a note',
    doctorOnboardRecordBody: 'Press and hold to record',
    doctorOnboardReview: 'Review and approve',
    doctorOnboardReviewBody: 'Review then approve',
    doctorTourStep: 'Step {n} of {total}',
    doctorTourWelcomeTitle: 'Welcome to Sawtna',
    doctorTourWelcomeBody:
      'A quick tour of your clinic workspace — patients, recording, notes, and settings.',
    doctorTourAddTitle: 'Add a patient',
    doctorTourAddBody: 'Tap here to create a patient profile before recording notes.',
    doctorTourRecordTitle: 'Hold to record',
    doctorTourRecordBody:
      'Press and hold the mic to dictate a visit. Release when you are done — we draft the clinical note.',
    doctorTourNotesTitle: 'Your notes',
    doctorTourNotesBody: 'All approved visit notes live here. Search, filter by date, and download PDFs.',
    doctorTourSettingsTitle: 'Clinic settings',
    doctorTourSettingsBody: 'Update your profile, clinic logo, language, and subscription here.',
    doctorTodayNotes: 'Today',
    doctorWeekNotes: 'This week',
    doctorTrial: 'Trial',
    doctorPlan: 'Plan',
    doctorRecentPatients: 'Recent Patients',
    doctorNoPatientsYet: 'No patients yet. Tap + to add one.',
    doctorSearchPatients: 'Search by name or MRN',
    doctorNewNote: 'New Note',
    doctorNewNoteCta: '+ New Note',
    doctorAddPatient: 'Add Patient',
    doctorEditPatient: 'Edit Patient',
    doctorAge: 'Age',
    doctorGender: 'Gender',
    doctorMale: 'Male',
    doctorFemale: 'Female',
    doctorOther: 'Other',
    doctorMRN: 'Medical record number',
    doctorKnownConditions: 'Known conditions',
    doctorAllergies: 'Allergies',
    doctorCurrentMeds: 'Current medications',
    doctorMedName: 'Medication name',
    doctorDose: 'Dose',
    doctorFrequency: 'Frequency',
    doctorPatientCreated: 'Patient created',
    doctorPatientUpdated: 'Patient updated',
    doctorPreviousVisits: 'Previous Visits',
    doctorNoPreviousVisits: 'No previous visits',
    doctorNoVisits: 'No visits yet',
    doctorPushToTalk: 'Push to Talk',
    doctorTrialBanner: '{n} notes remaining in free trial',
    doctorEmptyTranscript: 'No speech captured. Please try again.',
    doctorGenerating: 'Generating note...',
    doctorGeneratingHint: 'Building SOAP documentation from your recording',
    doctorGenerateFailed: 'Could not generate note. Please try again.',
    doctorApproveSave: 'Approve & Save',
    doctorSearchNotes: 'Search by patient or diagnosis',
    doctorFilterDate: 'Date',
    doctorClearDate: 'Clear date',
    doctorNoNotesYet: 'No notes yet',
    doctorNoNotesForFilters: 'No notes match these filters',
    doctorDownloadNote: 'Download note',
    doctorDownloadLanguagePrompt: 'Download this note in which language?',
    doctorDownloadFailed: 'Could not download note. Please try again.',
    doctorTranslatingNote: 'Translating note to Arabic…',
    doctorFilterAll: 'All',
    doctorFilterFirstVisit: 'First Visit',
    doctorFilterFollowUp: 'Follow-up',
    doctorFilterProcedure: 'Procedure',
    doctorFilterEmergency: 'Emergency',
    doctorBilledMonthly: 'Billed monthly',
    doctorSubscribeMonthly: 'Subscribe Monthly',
    doctorSubscribeAnnual: 'Subscribe Annually',
    doctorBestValue: 'Best Value',
    doctorSaveAnnual: 'Save 60 JOD — 10 JOD/month',
    doctorSubscriptionStarted: 'Subscription activated',
    doctorProfile: 'Profile',
    doctorClinicName: 'Clinic name',
    doctorClinicLogo: 'Clinic logo',
    doctorUploadLogo: 'Upload logo',
    doctorRemoveLogo: 'Remove logo',
    doctorLogoHint: 'Shown on notes and document PDFs',
    doctorLogoUploadFailed: 'Could not upload logo',
    doctorLogoUrl: 'Logo URL (optional)',
    doctorPreferences: 'Preferences',
    doctorSubscription: 'Subscription',
    doctorRemaining: 'remaining',
    doctorNotesUsed: 'Notes used',
    doctorNextBilling: 'Next billing date',
    doctorCancelSubscription: 'Cancel subscription',
    doctorSubscriptionCancelled: 'Subscription cancelled',
    doctorAccount: 'Account',
    doctorCurrentPassword: 'Current password',
    doctorNewPassword: 'New password',
    doctorChangePassword: 'Change password',
    doctorPasswordChanged: 'Password updated',
    doctorSettingsSaved: 'Settings saved',
    doctorSelectPatientToRecord: 'Open a patient, then tap the mic to record',
    doctorDetectPatientHint: 'Say the patient name — we will match them from your list',
    doctorWhoIsThisNote: 'Who is this note for?',
    doctorSelectPatientFromTranscript: 'We could not match a patient automatically. Select one:',
  },
  ar: {
    welcomeBack: 'مرحباً بعودتك',
    appSubtitle: 'صوتنا الأردن',
    yourName: 'اسمك',
    enterName: 'يرجى إدخال اسمك.',
    signIn: 'تسجيل الدخول',
    profile: 'الملف الشخصي',
    registeredNurse: 'ممرضة مسجلة',
    hospitalName: '',
    onShift: 'في الوردية',
    offShift: 'خارج الوردية',
    endShift: 'إنهاء الوردية',
    startShift: 'بدء الوردية',
    language: 'اللغة',
    english: 'English',
    arabic: 'العربية',
    feedback: 'ملاحظات',
    feedbackPlaceholder: 'أخبرنا المزيد',
    feedbackRequired: 'يرجى إدخال ملاحظاتك قبل الإرسال.',
    feedbackSubmitError: 'تعذر إرسال الملاحظات. حاول مرة أخرى.',
    feedbackSubmitting: 'جارٍ الإرسال...',
    submit: 'إرسال',
    save: 'حفظ',
    settingsSaved: 'تم حفظ الإعدادات.',
    thanksFeedback: 'شكراً لملاحظاتك!',
    signOut: 'تسجيل الخروج',
    patients: 'المرضى',
    notes: 'الملاحظات',
    vitals: 'العلامات الحيوية',
    medications: 'الأدوية',
    menu: 'القائمة',
    switchTo: 'الانتقال إلى',
    flowSheet: 'ورقة المتابعة',
    carePlans: 'خطط التمريض',
    noCarePlansYet: 'لا توجد خطط تمريض موثقة بعد. سجّل ملاحظة صوتية لإنشاء واحدة تلقائياً.',
    nursingDiagnosis: 'التشخيص التمريضي',
    carePlanGoals: 'الأهداف',
    carePlanInterventions: 'التدخلات',
    addIntervention: 'إضافة تدخل',
    deleteIntervention: 'حذف التدخل',
    carePlanEvaluation: 'التقييم',
    active: 'نشطة',
    resolved: 'مغلقة',
    markAsResolved: 'وضع علامة مغلقة',
    exportPdf: 'تصدير PDF',
    recordingWarning: 'التسجيل قيد التقدم. أوقف التسجيل قبل تبديل التبويبات.',
    all: 'الكل',
    favorites: 'المفضلة',
    prnAsNeeded: 'حسب الحاجة',
    prnBadge: 'حسب الحاجة',
    activeTasks: 'مهام نشطة',
    activeCarePlans: 'خطط التمريض',
    lastDocumented: 'آخر توثيق',
    neverDocumented: '—',
    taskSourceVoice: 'صوت',
    taskSourceCarePlan: 'خطة تمريض',
    taskSourceManual: 'يدوي',
    holdToDocument: 'اضغط مع الاستمرار للتوثيق',
    recurringTask: 'متكرر',
    documentTask: 'توثيق المهمة',
    documentToCompleteTask: 'وثّق لإكمال هذه المهمة.',
    recordToCompleteTask: 'وثّق لإكمال هذه المهمة.',
    recordToCompleteTaskHint: 'املأ الملاحظة أو استخدم الميكروفون لتوثيق هذه المهمة.',
    recordPainScoreBeforeSubmit: 'يرجى تسجيل درجة الألم قبل الإرسال.',
    recordBloodSugarBeforeSubmit: 'يرجى تسجيل مستوى السكر قبل الإرسال.',
    recordBloodPressureBeforeSubmit: 'يرجى تسجيل ضغط الدم قبل الإرسال.',
    painScoreBefore: 'درجة الألم قبل',
    painScoreAfter: 'درجة الألم بعد',
    bpBefore: 'ضغط الدم قبل',
    pulseOptional: 'النبض (اختياري)',
    bloodSugarBefore: 'سكر الدم قبل',
    bloodSugarAfter: 'سكر الدم بعد',
    inrOptional: 'INR (اختياري)',
    injectionSite: 'موقع الحقن',
    infusionRateOptional: 'معدل التسريب (اختياري)',
    volumeOptional: 'الحجم (اختياري)',
    adverseReactionNoted: 'لوحظ تفاعل عكسي',
    required: 'مطلوب',
    optional: 'اختياري',
    noMedicationTasks: 'لا توجد مهام أدوية.',
    noPrnTasks: 'لا توجد مهام حسب الحاجة.',
    noTasksScheduled: 'لا توجد مهام مجدولة.',
    shiftMorning: 'وردية الصباح',
    shiftAfternoon: 'وردية بعد الظهر',
    shiftNight: 'الوردية الليلية',
    filterByName: 'تصفية بالاسم',
    noPatientsFound: 'لم يتم العثور على مرضى',
    room: 'غرفة',
    age: 'العمر',
    allergies: 'الحساسية',
    diagnoses: 'التشخيصات',
    activeMedications: 'الأدوية النشطة',
    noneRecorded: 'لا يوجد',
    noMedications: 'لا توجد أدوية نشطة مسجلة.',
    completed: 'مكتمل',
    scheduledInProgress: 'مجدول / قيد التنفيذ',
    noCompletedTasks: 'لا توجد مهام مكتملة بعد.',
    noScheduledTasks: 'لا توجد مهام مجدولة.',
    backToPatients: 'العودة إلى المرضى',
    patientNotFound: 'المريض غير موجود',
    holdToRecord: 'اضغط مع الاستمرار للتسجيل',
    releaseToFinish: 'أفلت لإنهاء التسجيل',
    releaseToDiscard: 'أفلت للتجاهل',
    swipeLeftToDiscard: 'اسحب لليسار للتجاهل',
    connecting: 'جارٍ الاتصال...',
    cancelRecording: 'إلغاء التسجيل',
    noSpeechDetected: 'لم يتم اكتشاف كلام — اضغط مع الاستمرار وتحدث بوضوح.',
    noClinicalContent: 'لم يتم اكتشاف محتوى سريري — صف تفاصيل رعاية المريض وحاول مرة أخرى.',
    micDenied: 'تم رفض الوصول للميكروفون — يرجى السماح بإذن الميكروفون.',
    connectionError: 'تعذر الوصول لخدمة النسخ. تحقق من اتصال الإنترنت.',
    transcriptionError: 'خطأ في النسخ — يرجى المحاولة مرة أخرى.',
    transcriptionBusy: 'خدمة النسخ مشغولة — انتظر ثانية وحاول مرة أخرى.',
    transcriptionLost: 'انقطع اتصال النسخ — يرجى المحاولة مرة أخرى.',
    noNotesYet: 'لا توجد ملاحظات مسجلة بعد',
    noVitalsYet: 'لا توجد علامات حيوية مسجلة بعد',
    noMedicationsYet: 'لا توجد أدوية مسجلة بعد',
    noReportsYet: 'لا توجد تقارير بعد',
    analyzingTranscript: 'جارٍ تحليل النص...',
    translating: 'جارٍ الترجمة والتطبيع...',
    detectingNoteType: 'جارٍ تحديد نوع الملاحظة...',
    generatingNote: 'جارٍ إنشاء الملاحظة...',
    generatingMultiPatientProgress: 'جارٍ إنشاء ملاحظات للمريض {current} من {total}...',
    compilingShiftHandover: 'جاري تجميع تسليم الشيفت من ملاحظات الوردية...',
    compilingForPatient: 'جاري إنشاء التسليم لـ',
    mergingVoiceNote: 'جاري دمج الملاحظة الصوتية مع التسليم...',
    addFavorite: 'إضافة للمفضلة',
    removeFavorite: 'إزالة من المفضلة',
    allWards: 'جميع الأقسام',
    ward_ICU: 'العناية المركزة',
    ward_Medical: 'الباطنية',
    ward_Surgical: 'الجراحة',
    ward_Pediatrics: 'الأطفال',
    ward_Maternity: 'الولادة',
    unknownPatient: 'مريض غير معروف',
    overdueCount: '{count} متأخر',
    moreMedications: '+{count} أخرى',
    recordingHintGeneral: 'تحدث بشكل طبيعي بالعربية أو الإنجليزية أو كليهما. ابدأ باسم المريض ورقم الغرفة.',
    recordingHintPatient: 'تحدث بشكل طبيعي بالعربية أو الإنجليزية أو كليهما. المحتوى السريري فقط — المريض محدد مسبقاً.',
    preRecordHintGeneral: 'تحدث بشكل طبيعي بالعربية أو الإنجليزية أو كليهما. ابدأ باسم المريض ورقم الغرفة.',
    preRecordHintPatient: 'تحدث بشكل طبيعي بالعربية أو الإنجليزية أو كليهما. لا حاجة لذكر اسم المريض أو الغرفة — هذه الملاحظة للمريض المحدد.',
    selectPatientTitle: 'لأي مريض هذه الملاحظة؟',
    selectPatientSubtitle: 'اختر المريض الصحيح للمتابعة. يجب اختيار مريض قبل مراجعة هذه الملاحظة أو حفظها.',
    selectPatientMultiBadge: 'المريض {current} من {total}',
    selectPatientMultiTitle: 'تعذر مطابقة هذا المريض',
    selectPatientMultiSubtitle: 'تم التعرف على المرضى الآخرين بنجاح. اختر المريض الذي تخصه هذه الملاحظة.',
    selectPatientHeard: 'سمعنا في التسجيل',
    selectPatientRoomHeard: 'الغرفة المذكورة',
    selectPatientSegmentPreview: 'من تسجيلك',
    selectPatientAlreadyMatched: 'تمت مطابقتهم',
    selectPatientOther: 'مرضى آخرون',
    patientMatchRoomAndName: 'تطابق الغرفة والاسم',
    patientMatchRoom: 'تطابق الغرفة',
    patientMatchName: 'تطابق الاسم',
    patientMatchFuzzy: 'تطابق اسم قريب',
    noNoteToReview: 'لا توجد ملاحظة للمراجعة.',
    back: 'رجوع',
    reports: 'التقارير',
    shiftReports: 'تقارير الوردية والخروج',
    view: 'عرض',
    helpAndTutorial: 'المساعدة والدليل',
    viewTutorialAgain: 'عرض الدليل مرة أخرى',
    languageChanged: 'تم تحديث اللغة.',
    pending: 'قيد الانتظار',
    noPendingTasks: 'لا توجد مهام معلقة.',
    addTask: 'إضافة مهمة',
    taskDescription: 'وصف المهمة',
    taskDescriptionPlaceholder: 'مثال: فحص العلامات الحيوية ومستوى الألم',
    dueTimeOptional: 'وقت الاستحقاق (اختياري)',
    leaveEmptyOngoing: 'اتركه فارغاً لتعيينه كمهمة مستمرة.',
    priority: 'الأولوية',
    normal: 'عادي',
    high: 'عالي',
    overdueBy: 'متأخر بـ {minutes} د',
    ongoing: 'مستمر',
    dueNow: 'مستحق الآن',
    dueIn: 'مستحق خلال {minutes} د',
    dueAt: 'مستحق الساعة {time}',
    markComplete: 'تحديد كمكتمل',
    completedLabel: 'مكتمل',
    autoAdded: 'أُضيف تلقائياً',
    fromPreviousShift: 'من الوردية السابقة',
    updateFluid: 'تحديث ←',
    noEntriesYet: 'لا توجد إدخالات بعد',
    shiftComplete: 'اكتملت الوردية ✓',
    completedAtManually: 'اكتمل الساعة {time} — يدوياً',
    completedAtVia: 'اكتمل الساعة {time} عبر {source}',
    fromMarRecording: 'من تسجيل إعطاء الأدوية',
    fromProgressNote: 'من ملاحظة التقدم',
    fromHandover: 'من التسليم',
    fromVitalsRecording: 'من تسجيل العلامات الحيوية',
    vitalsRecording: 'تسجيل العلامات الحيوية',
    progressNoteRecording: 'تسجيل ملاحظة التقدم',
    marRecording: 'تسجيل إعطاء الأدوية',
    handoverRecording: 'تسجيل التسليم',
    admissionRecording: 'تسجيل القبول',
    dischargeRecording: 'تسجيل الخروج',
    bloodPressure: 'ضغط الدم',
    medication: 'دواء',
    progressNote: 'ملاحظة التقدم',
    progressNotePlaceholder: 'التقرير...',
    removeNote: 'إزالة الملاحظة',
    criticalHighAlert: 'حرج / تنبيه عالي',
    concernsCount: '{count} ملاحظة',
    concernsCountPlural: '{count} ملاحظات',
    warningsCount: '{count} تحذير',
    warningsCountPlural: '{count} تحذيرات',
    verifyCount: '{count} عنصر للتحقق',
    verifyCountPlural: '{count} عناصر للتحقق',
    hide: 'إخفاء',
    show: 'عرض',
    highAlertBanner: 'دواء عالي الخطورة — راجع بعناية قبل الحفظ.',
    verified: 'تم التحقق',
    discard: 'تجاهل',
    done: 'تم',
    saveToSession: 'حفظ في الجلسة',
    savedThisSession: 'محفوظ في هذه الجلسة',
    notesChronological: 'ترتيب زمني · سجل 24 ساعة',
    startRecordingFirstNote: 'ابدأ التسجيل لإنشاء أول ملاحظة.',
    medicationAdministration: 'إعطاء الأدوية',
    showCleaned: 'عرض النص المنظف',
    showOriginal: 'عرض النص الأصلي',
    followUpTasks: 'مهام المتابعة',
    add: 'إضافة',
    remove: 'إزالة',
    noneListed: 'لا يوجد.',
    noFollowUpTasks: 'لم يتم اكتشاف مهام متابعة.',
    fillSoapSection: 'يرجى ملء قسم واحد على الأقل من SOAP.',
    fillVitalValue: 'يرجى إدخال قيمة علامة حيوية واحدة على الأقل.',
    fillMedicationField: 'يرجى ملء حقل دواء واحد على الأقل.',
    fillSbarSection: 'يرجى ملء قسم واحد على الأقل من SBAR.',
    fillOneField: 'يرجى ملء حقل واحد على الأقل قبل الحفظ.',
    failedProcessRecording: 'فشل معالجة التسجيل.',
    admitNewPatient: 'قبول مريض جديد',
    reportShiftHandover: 'تسليم الوردية',
    reportDischarge: 'خروج',
    reportIncident: 'حادث',
    timeLabel: 'الوقت',
    timeOfCare: 'وقت الرعاية',
    lateEntry: 'إدخال متأخر',
    today: 'اليوم',
    yesterday: 'أمس',
    notSpecified: 'غير محدد',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    addAddendum: 'إضافة ملحق',
    addAddendumButton: '+ ملحق',
    addAddendumSubtitle:
      'لا يمكن تعديل الملاحظة الأصلية. سيتم إرفاق هذا الملحق بها مع طابع زمني جديد.',
    addAddendumPlaceholder: 'صف التصحيح أو المعلومات الإضافية...',
    addAddendumRequired: 'يرجى إدخال نص الملحق.',
    saveAddendum: 'حفظ الملحق',
    saving: 'جارٍ الحفظ…',
    addendumAddedAt: 'ملحق — أُضيف في {time}',
    conditionAtDischarge: 'الحالة عند الخروج',
    dischargeMode: 'طريقة الخروج',
    accompaniedBy: 'بصحبة',
    specialInstructions: 'تعليمات خاصة',
    dischargeEducation: 'تثقيف الخروج',
    followUp: 'المتابعة',
    physician: 'الطبيب',
    timeframe: 'المدة الزمنية',
    patientUnderstands: 'المريض يفهم',
    familyUnderstands: 'العائلة تفهم',
    patientCopyArabic: 'نسخة المريض (عربي)',
    generating: 'جارٍ الإنشاء…',
    viewTranscript: 'عرض النص',
    male: 'ذكر',
    female: 'أنثى',
    copy: 'نسخ',
    copied: 'تم النسخ!',
    loading: 'جارٍ التحميل',
    close: 'إغلاق',
    shiftHandover: 'تسليم الوردية',
    fluidBalance: 'ميزان السوائل',
    fluidBalanceListSubtitle: 'ميزان السوائل خلال 24 ساعة حسب المريض',
    fluidBalanceNetBadge: 'ميزان السوائل · صافي {net} مل',
    confirmGiven: 'تأكيد الإعطاء',
    notGiven: 'لم يُعطَ',
    submitDeviation: 'إرسال الانحراف',
    selectDeviationReason: 'سبب عدم الإعطاء',
    otherReason: 'سبب آخر',
    speakOrTypeReason: 'تحدّث أو اكتب السبب',
    medicationDeviations: 'انحرافات — لم تُعطَ',
    notGivenWithReason: 'لم يُعطَ: {reason}',
    deviationPatientRefused: 'المريض رفض',
    deviationPatientAway: 'المريض خارج القسم',
    deviationMedNotAvailable: 'الدواء غير متوفر',
    deviationPatientNpo: 'المريض صائم (NPO)',
    deviationPhysicianHeld: 'أوقف الطبيب الدواء',
    deviationVitalsOutside: 'العلامات الحيوية خارج الحدود',
    deviationPatientVomited: 'المريض تقيأ',
    deviationOther: 'أخرى',
    units: 'وحدات',
    freqWeekly: 'أسبوعياً',
    freqBid: 'مرتين يومياً',
    freqTid: 'ثلاث مرات يومياً',
    freqOd: 'مرة يومياً',
    freqDaily: 'يومياً',
    freqQ4h: 'كل 4 ساعات',
    freqQ6h: 'كل 6 ساعات',
    freqQ6hPrn: 'كل 6 ساعات عند الحاجة',
    freqQ8h: 'كل 8 ساعات',
    freqPrn: 'عند الحاجة',
    freqPrnSuffix: 'عند الحاجة',
    taskPatientRepositioning: 'إعادة تموضع المريض',
    taskNeurologicalAssessment: 'التقييم العصبي',
    taskBloodSugarMonitoring: 'مراقبة سكر الدم',
    taskWoundSiteAssessment: 'فحص موقع الجرح',
    taskPainAssessment: 'تقييم الألم',
    taskPainAssessmentPediatric: 'تقييم الألم (FLACC/Wong-Baker)',
    taskDrainOutputCheck: 'فحص إخراج التصريف',
    taskGrowthDevelopmentCheck: 'فحص النمو والتطور',
    taskParentGuardianUpdate: 'تحديث ولي الأمر',
    taskFetalHeartRateMonitoring: 'مراقبة نبض الجنين',
    taskFundalHeightAssessment: 'قياس ارتفاع القاع',
    taskLochiaAssessment: 'تقييم النفاس',
    taskBreastfeedingSupport: 'دعم الرضاعة الطبيعية',
    taskNewbornAssessment: 'تقييم المولود',
    fluidBalanceProgress: 'داخل: {in} مل | خارج: {out} مل | الرصيد: {balance} مل',
    doseMismatchMessage: 'الجرعة المسجلة ({documented}) لا تطابق جرعة المهمة المعلقة ({expected} لـ {taskLabel}). يرجى التأكد من صحتها قبل الحفظ.',
    doseMismatchValue: '{drugName}: مسجلة {documented}، المهمة تتطلب {expected}',
    consentTitle: 'قبل أن تبدأ',
    consentSubtitle: 'يرجى مراجعة وقبول ما يلي قبل استخدام صوتنا',
    consentTermsPrefix: 'لقد قرأت وأوافق على',
    consentTermsOfService: 'شروط الخدمة',
    consentAnd: 'و',
    consentPrivacyPolicy: 'سياسة الخصوصية',
    consentVoiceLabel:
      'أسمح لصوتنا باستخدام تسجيلاتي الصوتية لتحسين دقة التفريغ النصي. يساعد هذا صوتنا على التحسن مع الوقت. يمكنك استخدام صوتنا حتى إذا رفضت.',
    consentGetStarted: 'ابدأ',
    consentSubmitting: 'جارٍ الحفظ…',
    consentSubmitError: 'تعذر حفظ موافقتك. حاول مرة أخرى.',
    skip: 'تخطّي',
    next: 'التالي',
    viewAll: 'عرض الكل',
    doctorPatients: 'المرضى',
    doctorNotes: 'الملاحظات',
    doctorSettings: 'الإعدادات',
    doctorHowDoYouFindIt: 'كيف تجد التجربة؟',
    doctorFeedbackOptionalHint: 'اختياري — اختر إعجاباً أو عدم إعجاب، ويمكنك إضافة ملاحظة.',
    doctorFeedbackThumbsUp: 'إعجاب',
    doctorFeedbackThumbsDown: 'عدم إعجاب',
    doctorHome: 'الرئيسية',
    doctorFullName: 'الاسم الكامل',
    doctorPhoneOptional: 'الهاتف (اختياري)',
    doctorPhone: 'الهاتف',
    doctorOptional: 'اختياري',
    doctorSelectGender: 'اختر…',
    doctorCreateAccount: 'إنشاء حساب',
    doctorHaveAccount: 'لديك حساب؟ سجّل الدخول',
    doctorBackToEntry: 'العودة لاختيار نوع الحساب',
    doctorGetStarted: 'ابدأ',
    doctorSignupStep1Title: 'أنشئ حسابك',
    doctorSignupStep1Body: 'الاسم والبريد وكلمة المرور — أقل من دقيقة.',
    doctorSignupStep2Title: 'عيادتك',
    doctorSignupStep2Body: 'تفاصيل اختيارية للملفات الشخصية وملفات PDF. يمكنك التخطي.',
    doctorSignupContinue: 'متابعة',
    doctorSignupFinish: 'ابدأ استخدام صوتنا',
    doctorSignupSkip: 'تخطّي الآن',
    doctorSpecialty: 'التخصص',
    doctorCountry: 'الدولة',
    doctorNoteFormat: 'صيغة الملاحظة',
    doctorClinicNamePlaceholder: 'مثال: عيادة النور',
    doctorOnboardAddPatient: 'أضف أول مريض',
    doctorOnboardAddPatientBody: 'اضغط + لإضافة مريض',
    doctorOnboardRecord: 'سجّل ملاحظة',
    doctorOnboardRecordBody: 'اضغط مع الاستمرار للتسجيل',
    doctorOnboardReview: 'راجع واعتمد',
    doctorOnboardReviewBody: 'راجع ثم اعتمد',
    doctorTourStep: 'الخطوة {n} من {total}',
    doctorTourWelcomeTitle: 'مرحباً بك في صوتنا',
    doctorTourWelcomeBody:
      'جولة سريعة في مساحة عيادتك — المرضى، التسجيل، الملاحظات، والإعدادات.',
    doctorTourAddTitle: 'إضافة مريض',
    doctorTourAddBody: 'اضغط هنا لإنشاء ملف مريض قبل تسجيل الملاحظات.',
    doctorTourRecordTitle: 'اضغط مع الاستمرار للتسجيل',
    doctorTourRecordBody:
      'اضغط مع الاستمرار على الميكروفون لإملاء الزيارة. أفلت عند الانتهاء — نُنشئ المسودة السريرية.',
    doctorTourNotesTitle: 'ملاحظاتك',
    doctorTourNotesBody: 'كل الملاحظات المعتمدة هنا. ابحث، صفِّ حسب التاريخ، وحمّل ملفات PDF.',
    doctorTourSettingsTitle: 'إعدادات العيادة',
    doctorTourSettingsBody: 'حدّث ملفك وشعار العيادة واللغة والاشتراك من هنا.',
    doctorTodayNotes: 'اليوم',
    doctorWeekNotes: 'هذا الأسبوع',
    doctorTrial: 'تجربة',
    doctorPlan: 'الخطة',
    doctorRecentPatients: 'المرضى الأخيرون',
    doctorNoPatientsYet: 'لا يوجد مرضى بعد. اضغط + للإضافة.',
    doctorSearchPatients: 'ابحث بالاسم أو رقم الملف',
    doctorNewNote: 'ملاحظة جديدة',
    doctorNewNoteCta: '+ ملاحظة جديدة',
    doctorAddPatient: 'إضافة مريض',
    doctorEditPatient: 'تعديل مريض',
    doctorAge: 'العمر',
    doctorGender: 'الجنس',
    doctorMale: 'ذكر',
    doctorFemale: 'أنثى',
    doctorOther: 'آخر',
    doctorMRN: 'رقم الملف الطبي',
    doctorKnownConditions: 'الأمراض المعروفة',
    doctorAllergies: 'الحساسية',
    doctorCurrentMeds: 'الأدوية الحالية',
    doctorMedName: 'اسم الدواء',
    doctorDose: 'الجرعة',
    doctorFrequency: 'التكرار',
    doctorPatientCreated: 'تم إنشاء المريض',
    doctorPatientUpdated: 'تم تحديث المريض',
    doctorPreviousVisits: 'الزيارات السابقة',
    doctorNoPreviousVisits: 'لا توجد زيارات سابقة',
    doctorNoVisits: 'لا زيارات بعد',
    doctorPushToTalk: 'اضغط للتحدث',
    doctorTrialBanner: '{n} ملاحظات متبقية في الفترة التجريبية',
    doctorEmptyTranscript: 'لم يتم التقاط كلام. حاول مرة أخرى.',
    doctorGenerating: 'جاري إنشاء الملاحظة...',
    doctorGeneratingHint: 'بناء توثيق SOAP من تسجيلك',
    doctorGenerateFailed: 'تعذر إنشاء الملاحظة. حاول مرة أخرى.',
    doctorApproveSave: 'اعتماد وحفظ',
    doctorSearchNotes: 'ابحث باسم المريض أو التشخيص',
    doctorFilterDate: 'التاريخ',
    doctorClearDate: 'مسح التاريخ',
    doctorNoNotesYet: 'لا توجد ملاحظات بعد',
    doctorNoNotesForFilters: 'لا توجد ملاحظات مطابقة',
    doctorDownloadNote: 'تحميل الملاحظة',
    doctorDownloadLanguagePrompt: 'تحميل هذه الملاحظة بأي لغة؟',
    doctorDownloadFailed: 'تعذر تحميل الملاحظة. حاول مرة أخرى.',
    doctorTranslatingNote: 'جاري ترجمة الملاحظة إلى العربية…',
    doctorFilterAll: 'الكل',
    doctorFilterFirstVisit: 'زيارة أولى',
    doctorFilterFollowUp: 'متابعة',
    doctorFilterProcedure: 'إجراء',
    doctorFilterEmergency: 'طوارئ',
    doctorBilledMonthly: 'يُفوتر شهرياً',
    doctorSubscribeMonthly: 'اشترك شهرياً',
    doctorSubscribeAnnual: 'اشترك سنوياً',
    doctorBestValue: 'أفضل قيمة',
    doctorSaveAnnual: 'وفّر 60 دينار — 10 دينار/شهر',
    doctorSubscriptionStarted: 'تم تفعيل الاشتراك',
    doctorProfile: 'الملف الشخصي',
    doctorClinicName: 'اسم العيادة',
    doctorClinicLogo: 'شعار العيادة',
    doctorUploadLogo: 'رفع الشعار',
    doctorRemoveLogo: 'إزالة الشعار',
    doctorLogoHint: 'يظهر على ملفات الملاحظات والمستندات',
    doctorLogoUploadFailed: 'تعذر رفع الشعار',
    doctorLogoUrl: 'رابط الشعار (اختياري)',
    doctorPreferences: 'التفضيلات',
    doctorSubscription: 'الاشتراك',
    doctorRemaining: 'متبقية',
    doctorNotesUsed: 'الملاحظات المستخدمة',
    doctorNextBilling: 'تاريخ الفوترة التالي',
    doctorCancelSubscription: 'إلغاء الاشتراك',
    doctorSubscriptionCancelled: 'تم إلغاء الاشتراك',
    doctorAccount: 'الحساب',
    doctorCurrentPassword: 'كلمة المرور الحالية',
    doctorNewPassword: 'كلمة المرور الجديدة',
    doctorChangePassword: 'تغيير كلمة المرور',
    doctorPasswordChanged: 'تم تحديث كلمة المرور',
    doctorSettingsSaved: 'تم حفظ الإعدادات',
    doctorSelectPatientToRecord: 'افتح مريضاً ثم اضغط الميكروفون للتسجيل',
    doctorDetectPatientHint: 'اذكر اسم المريض — سنطابقه من قائمتك',
    doctorWhoIsThisNote: 'لمن هذه الملاحظة؟',
    doctorSelectPatientFromTranscript: 'تعذر التعرف على المريض تلقائياً. اختر من القائمة:',
  },
};

export function getNurseDisplayName(name, language) {
  if (!name) return '';
  const arMap = {
    'sarah al-hassan': 'سارة الحسن',
    'sarah al hassan': 'سارة الحسن',
    'سارة الحسن': 'سارة الحسن',
  };
  const enMap = {
    'سارة الحسن': 'Sarah Al-Hassan',
  };
  const key = name.toLowerCase().trim();
  if (language === 'ar') {
    return arMap[key] || (/[\u0600-\u06FF]/.test(name) ? name : name);
  }
  if (/[\u0600-\u06FF]/.test(name)) {
    return enMap[name.trim()] || name;
  }
  return name;
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function translateWard(t, ward) {
  if (ward === 'All Wards') return t('allWards');
  return t(`ward_${ward}`) || ward;
}

export function getReportTypeLabel(t, type) {
  if (type === 'shift_handover') return t('reportShiftHandover');
  if (type === 'discharge') return t('reportDischarge');
  if (type === 'incident') return t('reportIncident');
  return type?.replaceAll('_', ' ') || '';
}

export function pluralKey(t, count, singularKey, pluralKeyName) {
  return t(count === 1 ? singularKey : pluralKeyName, { count });
}
